import React from 'react';
import {paths} from '../../common/dictionaries/urls';
import WarrantyAdmin from './insert';
import ExcelWarrantyInsert from './insertExcel';

export const adminWarrantyRoutes = [
  {
    'component': <WarrantyAdmin />,
    'path': paths.WarrantyAdminEditForm,
  },
  {
    'component': <ExcelWarrantyInsert />,
    'path': paths.ExcelWarrantyInsert,
  },
];
